import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLanguage();
  const faqItems = [{
    question: t('faq.q1'),
    answer: t('faq.a1')
  }, {
    question: t('faq.q2'),
    answer: t('faq.a2')
  }, {
    question: t('faq.q3'),
    answer: t('faq.a3')
  }, {
    question: t('faq.q4'),
    answer: t('faq.a4')
  }, {
    question: t('faq.q5'),
    answer: t('faq.a5')
  }];
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" ref={ref} className="relative w-full overflow-hidden px-4 py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-254">
      <div className="relative z-10 mx-auto max-w-3xl" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-256">
          <h2 className="text-3xl md:text-4xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-257">
            {t('faq.title')} {t('faq.titleHighlight')}
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-258">
          {faqItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-259">
              <div className="rounded-2xl border overflow-hidden" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-260">
                <button onClick={() => toggleItem(index)} className="flex w-full items-center justify-between p-6 text-left transition-colors" aria-expanded={openIndex === index} data-id="element-261">
                  <h3 className="pr-4 font-medium text-base" style={{
                color: 'var(--text-primary)'
              }} data-id="element-262">
                    {item.question}
                  </h3>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-263">
                    <ChevronDownIcon className="h-5 w-5" style={{
                  color: 'var(--accent)'
                }} data-id="element-264" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-265">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-266">
                      <div className="border-t px-6 pb-6 pt-4" style={{
                  borderColor: 'var(--border)'
                }} data-id="element-267">
                        <p className="leading-relaxed" style={{
                    color: 'var(--text-secondary)'
                  }} data-id="element-268">
                          {item.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}